import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import VtGrid from '@/components/VtGrid/VtGrid.vue'
import GridDisplayOptions from '@/components/GridDisplayOptions.vue'
import {
    initialStatisticalAnalysisViewDetailTableState,
    StatisticalAnalysisViewDetailTableState
} from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-table/statistical-analysis-view-detail-table.model'
import { GetContextMenuItemsParams, GridOptions, MenuItemDef } from '@ag-grid-enterprise/all-modules'
import StatisticalAnalysisViewDetailTableGrouping from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-table-grouping/statistical-analysis-view-detail-table-grouping.vue'
import StatisticalAnalysisTemporalFilter from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-temporal-filter/statistical-analysis-temporal-filter.vue'
import { StatisticalAnalysisTemporalFilterEnum, StatisticalAnalysisTemporalFilterOptions } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-temporal-filter/statistical-analysis-temporal-filter.model'
import { StatisticalAnalysisGroupingResponseField } from '@/modules/statistical-analysis-module/shared/services/statistical-analysis-grouping/statistical-analysis-grouping.dto'
import { StatisticalAnalysisDossiersDatasourceResponsesTypes, StatisticalAnalysisDossiersExternalInfo, StatisticalAnalysisViewDetailParams } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { statisticalAnalysisHandlerFactory } from '@/modules/statistical-analysis-module/handlers/statistical-analysis-handler.factory'
import { uniqueId } from 'lodash'
import { AgGridCallbackEvent } from '@/shared/models/ag-grid.model'
import { StatisticalAnalysisDatasource } from '@/modules/statistical-analysis-module/handlers/statistical-analysis-datasource'
import StatisticAnalysisExternalViewDetailTable from '@/modules/statistical-analysis-module/components/statistical-analysis-external-views/statistical-analysis-external-views-detail-table/statistical-analysis-external-views-detail-table.vue'
import BaseCrudInfiniteServerSideComponent from '@/shared/resources/base-crud-infinite-side.component'
import StatisticAnalysisExternalViewDetailChart from '@/modules/statistical-analysis-module/components/statistical-analysis-external-views/statistical-analysis-external-views-detail-chart/statistical-analysis-external-views-detail-chart.vue'
import { AxiosResponse } from 'axios'
import { CommonExportType } from '@/api/resources/common/shared/models/common.models'

@Component({
    components: {
        VtGrid,
        GridDisplayOptions,
        StatisticalAnalysisViewDetailTableGrouping,
        StatisticAnalysisExternalViewDetailTable,
        StatisticAnalysisExternalViewDetailChart,
        StatisticalAnalysisTemporalFilter
    }
})
export default class StatisticalAnalysisViewDetailTable extends Mixins<BaseCrudInfiniteServerSideComponent<StatisticalAnalysisDossiersDatasourceResponsesTypes>>(BaseCrudInfiniteServerSideComponent) {
    @Prop() readonly externalInfo!: StatisticalAnalysisDossiersExternalInfo
    @Prop() readonly viewDetailParams!: StatisticalAnalysisViewDetailParams
    @Prop(Object) readonly rows!: StatisticalAnalysisViewDetailTableGrouping
    @Prop(Object) readonly columns!: object
    @Watch('externalInfo', { deep: true })
    async onExternalInfoChanged(value: StatisticalAnalysisDossiersExternalInfo) {
        if (value) {
            this.stateTable.filters.externalFiltering.sidebarFilters = value
            this.state.columnsDef = this.instanceDatasource?.getGridColumns()
            this.state.updateGrid = uniqueId()
            this.instanceDatasource = statisticalAnalysisHandlerFactory.getDatasource(this.viewDetailParams.dossier, this.stateTable.filters)
        }
    }
    stateTable!:StatisticalAnalysisViewDetailTableState
    instanceDatasource!: StatisticalAnalysisDatasource<StatisticalAnalysisDossiersDatasourceResponsesTypes> | null
    constructor() {
        super()
        this.stateTable = initialStatisticalAnalysisViewDetailTableState()
    }

    get gridOptionsTable(): GridOptions {
        return {
            ...this.gridOptions,
            defaultColDef: {
                resizable: true,
                suppressMenu: true
            }
        }
    }

    get tableIsVisible(): boolean {
        return this.stateTable.filters.grouping?.length! >= 0
    }

    get showTemporalFilter(): boolean {
        return this.viewDetailParams.table?.temporalFilter?.isShow as boolean
    }

    get preselectionTemporalFilter(): StatisticalAnalysisTemporalFilterEnum {
        return this.viewDetailParams.table?.temporalFilter?.preselection as StatisticalAnalysisTemporalFilterEnum
    }

    get isLoading(): boolean {
        return this.stateTable.loading
    }

    openList(row: StatisticalAnalysisDossiersDatasourceResponsesTypes): void {
        this.stateTable.showModalTable = true
        this.stateTable.rowSelected = row
    }

    openGraphic(row: StatisticalAnalysisDossiersDatasourceResponsesTypes): void {
        this.stateTable.showModalChart = true
        this.stateTable.rowSelected = row
    }

    onSelectionFields(value: StatisticalAnalysisGroupingResponseField[]): void {
        this.stateTable.filters.grouping = value
        this.instanceDatasource = statisticalAnalysisHandlerFactory.getDatasource(this.viewDetailParams.dossier, this.stateTable.filters)
        this._emitEventVtGridLoading(true)
        this.stateTable.filters.externalFiltering.sidebarFilters = this.externalInfo
        this._setDatasource()
    }

    onTemporalFilter(value: StatisticalAnalysisTemporalFilterOptions): void {
        this.stateTable.filters.temporalFilter = value.id
        this._reloadData()
    }

    onEndCallback(_event: AgGridCallbackEvent) {
        this._emitEventVtGridLoading(false)
    }

    onChangedMode(mode: any) {
        this.changedMode(mode)
    }

    onChangedPageSize(size: number) {
        this.changedPageSize(size)
    }

    onHideModalTable(value: boolean): void {
        this.stateTable.showModalTable = value
    }

    onHideModalChart(value: boolean): void {
        this.stateTable.showModalChart = value
    }

    getContextMenuItems(params: GetContextMenuItemsParams): MenuItemDef[] {
        if (!params?.node) {
            return []
        } else {
            let selectedRows = this.state?.gridApi?.getSelectedRows()!
            return [
                {
                    name: this.$t('statisticalAnalysis.grids.contextMenu.viewList').toString(),
                    action: () => this.openList(params?.node?.data),
                    cssClasses: this.viewDetailParams.table.contextMenuItems.detailList && selectedRows.length === 1 ? [''] : ['not-show']
                },
                {
                    name: this.$t('statisticalAnalysis.grids.contextMenu.viewChart').toString(),
                    action: () => this.openGraphic(params?.node?.data),
                    cssClasses: this.viewDetailParams.table.contextMenuItems.detailChart && selectedRows.length === 1 ? [''] : ['not-show']
                }
            ]
        }
    }

    exportReport(exportType: CommonExportType): Promise<AxiosResponse<Blob>> | null {
        const columns = this.getColumnsToExport()
        if (columns) {
            const instanceToExport =
                statisticalAnalysisHandlerFactory.getTableExporting(
                    this.viewDetailParams.dossier,
                    this.stateTable.filters,
                    columns,
                    this.state.selectedRows
                )
            if (instanceToExport) {
                return instanceToExport.exportTo(exportType)
            }
        }
        return null
    }

    private _reloadData(): void {
        this._emitEventVtGridLoading(true)
        this.reloadData()
    }

    private _emitEventVtGridLoading(value: boolean): void {
        this.stateTable.loading = value
        this.$eventHub.$emit('statistical-loading', value)
    }

    private _setDatasource(): void {
        this.state.columnsDef = this.instanceDatasource?.getGridColumns()
        this.state.updateGrid = uniqueId()
        this.state.datasource.service = this.instanceDatasource
    }
}
